<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Form ref="memberInfo" :model="memberInfo" :rules="ruleValidate" :label-width="80">
              <FormItem label="会员姓名" prop="memberName">
                <Input v-model="memberInfo.memberName" placeholder="请您输入会员姓名"></Input>
              </FormItem>
              <FormItem label="会员性别" prop="memberGender">
                <RadioGroup v-model="memberInfo.memberGender">
                  <Radio label="男"></Radio>
                  <Radio label="女"></Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="年龄段" prop="ageGroup">
                <RadioGroup v-model="memberInfo.ageGroup">
                  <Radio label="less50">50岁以下</Radio>
                  <Radio label="50between85">50岁～85岁</Radio>
                  <Radio label="over85">85岁以上</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="出生日期" prop="birthday" v-if="memberInfo.ageGroup=='50between85'">
                <DatePicker type="date" placeholder="选择会员出生日期" format="yyyy-MM-dd" v-model="memberInfo.birthday"></DatePicker>
              </FormItem>
              <FormItem label="出生地" prop="memberNative">
                <Input v-model="memberInfo.memberNative" placeholder="请您输入会员出生地"></Input>
              </FormItem>
              <FormItem label="民族" prop="memberNation">
                <Select v-model="memberInfo.memberNation" placeholder="请您选择会员民族">
                  <Option value="汉族">汉族</Option>
                  <Option value="满族">满族</Option>
                  <Option value="蒙古族">蒙古族</Option>
                  <Option value="回族">回族</Option>
                  <Option value="藏族">藏族</Option>
                  <Option value="维吾尔族">维吾尔族</Option>
                  <Option value="苗族">苗族</Option>
                  <Option value="彝族">彝族</Option>
                  <Option value="壮族">壮族</Option>
                  <Option value="布依族">布依族</Option>
                  <Option value="侗族">侗族</Option>
                  <Option value="瑶族">瑶族</Option>
                  <Option value="白族">白族</Option>
                  <Option value="土家族">土家族</Option>
                  <Option value="哈尼族">哈尼族</Option>
                  <Option value="哈萨克族">哈萨克族</Option>
                  <Option value="傣族">傣族</Option>
                  <Option value="黎族">黎族</Option>
                  <Option value="傈僳族">傈僳族</Option>
                  <Option value="佤族">佤族</Option>
                  <Option value="畲族">畲族</Option>
                  <Option value="高山族">高山族</Option>
                  <Option value="拉祜族">拉祜族</Option>
                  <Option value="水族">水族</Option>
                  <Option value="东乡族">东乡族</Option>
                  <Option value="纳西族">纳西族</Option>
                  <Option value="景颇族">景颇族</Option>
                  <Option value="柯尔克孜族">柯尔克孜族</Option>
                  <Option value="土族">土族</Option>
                  <Option value="达斡尔族">达斡尔族</Option>
                  <Option value="仫佬族">仫佬族</Option>
                  <Option value="羌族">羌族</Option>
                  <Option value="布朗族">布朗族</Option>
                  <Option value="撒拉族">撒拉族</Option>
                  <Option value="毛南族">毛南族</Option>
                  <Option value="仡佬族">仡佬族</Option>
                  <Option value="锡伯族">锡伯族</Option>
                  <Option value="阿昌族">阿昌族</Option>
                  <Option value="普米族">普米族</Option>
                  <Option value="朝鲜族">朝鲜族</Option>
                  <Option value="塔吉克族">塔吉克族</Option>
                  <Option value="怒族">怒族</Option>
                  <Option value="乌孜别克族">乌孜别克族</Option>
                  <Option value="俄罗斯族">俄罗斯族</Option>
                  <Option value="鄂温克族">鄂温克族</Option>
                  <Option value="德昂族">德昂族</Option>
                  <Option value="保安族">保安族</Option>
                  <Option value="裕固族">裕固族</Option>
                  <Option value="京族">京族</Option>
                  <Option value="塔塔尔族">塔塔尔族</Option>
                  <Option value="独龙族">独龙族</Option>
                  <Option value="鄂伦春族">鄂伦春族</Option>
                  <Option value="赫哲族">赫哲族</Option>
                  <Option value="门巴族">门巴族</Option>
                  <Option value="珞巴族">珞巴族</Option>
                  <Option value="基诺族">基诺族</Option>
                </Select>
              </FormItem>
              <FormItem label="职称" prop="memberTitle">
                <Select v-model="memberInfo.memberTitle" placeholder="请您选择会员职称">
                  <Option value="正教授">正教授</Option>
                  <Option value="副教授">副教授</Option>
                  <Option value="正研究员">正研究员</Option>
                  <Option value="副研究员">副研究员</Option>
                  <Option value="其他正高级">其他正高级</Option>
                  <Option value="其他副高级">其他副高级</Option>
                </Select>
              </FormItem>
              <FormItem label="职务" prop="profession">
                <Input v-model="memberInfo.profession" placeholder="请您输入会员职务"></Input>
              </FormItem>
              <FormItem label="联系电话" prop="memberTel">
                <Input v-model="memberInfo.memberTel" placeholder="请您输入会员联系电话"></Input>
              </FormItem>
              <FormItem label="会员介绍" prop="memberDesc">
                <ckeditor v-model="memberInfo.memberDesc" :config="editorConfig" placeholder="请您输入会员介绍"></ckeditor>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('memberInfo')">保存会员信息</Button>
              </FormItem>
            </Form>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  //数据
  data() {
    return {
      token: '',
      // 文本编辑器配置
      editorConfig: {
        language: 'zh-cn',//中文包
        fileTools_requestHeaders: {
          "Authorization": ""
        },
        extraPlugins:['font', 'justify', 'colorbutton'],
        filebrowserImageUploadUrl: this.GLOBAL_API.apiUrl + '/uploads/picture-for-editor',
      },
      memberInfo: {},
      ruleValidate: {
        memberName: [
          { required: true, message: '请您输入会员姓名', trigger: 'blur' }
        ],
        memberGender: [
          { required: true, message: '请您选择会员性别', trigger: 'change' }
        ],
        ageGroup: [
          { required: true, message: '请您选择会员年龄段', trigger: 'change' }
        ],
        birthday: [
          { required: true, type: 'date', message: '请您选择会员出生日期', trigger: 'change' }
        ],
        memberNative: [
          { required: true, message: '请您输入会员出生地', trigger: 'blur' }
        ],
        memberNation: [
          { required: true, message: '请您选择会员民族', trigger: 'change' }
        ],
        memberTitle: [
          { required: true, message: '请您选择会员职称', trigger: 'change' }
        ],
        profession: [
          { required: true, message: '请您输入会员职务', trigger: 'blur' }
        ],
        memberTel: [
          { required: true, message: '请您输入会员联系电话', trigger: 'blur' }
        ],
        memberDesc: [
          { required: true, message: '请您输入会员介绍', trigger: 'blur' }
        ],
      }
    }
  },

  //加载后执行
  mounted() {
    //初始化页面数据
    this.initAuthData()

    //获取会员列表
    this.getMemberInfo()
  },
  
  //自定义函数
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
        this.editorConfig.fileTools_requestHeaders.Authorization = "Bearer " + admin.token
      }
    },

    //获取会员列表
    getMemberInfo() {
      let vm = this
      let memberId = parseInt(vm.$route.query.id)
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/info-get-for-show",
        {memberId: memberId, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.memberInfo = info.data
        //console.log(info)
      }).catch(function(error) {
        console.log(error)
      });
    },

    //表单数据提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this
          axios.post(
            vm.GLOBAL_API.apiUrl + "/manage/members/info-save-for-edit",
            vm.memberInfo,
            {
              headers: {
                'content-type': 'application/json',
                "Authorization": "Bearer " + vm.token
              }
            }
          ).then(function(res) {
            let info = res.data
            let error = parseInt(info.code)
            if(error==0) {
              vm.$Message.success({
                content: info.message,
                duration: 1,
                closable: true,
                onClose:function() {
                  window.close()
                }
              });
            } else {
              vm.$Message.error(info.message);
            }
          }).catch(function(error) {
            console.log(error)
          });
        } else {
          this.$Message.error('Fail!');
        }
      })
    },

  }
}
</script>